import CheckBox from "./checkBox";

export default CheckBox;
